import React from 'react';
import { TimePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import { useFilterLayoutStyles } from '../utils/languageUtils';

interface TimePickerFilterProps {
    label?: string;
    value?: Dayjs | null;
    onChange?: (time: Dayjs | null) => void;
    className?: string;
    spanClassName?: string;
    disabled?: boolean;
    placeholder?: string;
    required?: boolean;
    forceHorizontal?: boolean;
    format?: string;
    minuteStep?: number;
    showNow?: boolean;
    allowClear?: boolean;
}

/**
 * 时间选择器过滤项
 * @description 结合标签和TimePicker的公共组件，支持水平和竖直布局
 */
const TimePickerFilter: React.FC<TimePickerFilterProps> = ({
    label,
    value,
    onChange,
    className,
    spanClassName,
    disabled = false,
    placeholder,
    required = false,
    forceHorizontal,
    format = 'HH:mm',
    minuteStep = 1,
    showNow = false,
    allowClear = true,
}) => {
    const { containerClassName, labelClassName, inputContainerClassName } = useFilterLayoutStyles(spanClassName, className, forceHorizontal);

    return (
        <div className={containerClassName}>
            {label && (
                <span className={labelClassName}>
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </span>
            )}
            <div className={inputContainerClassName}>
                <TimePicker
                    value={value}
                    onChange={onChange}
                    format={format}
                    placeholder={placeholder}
                    size="middle"
                    className="w-full"
                    allowClear={allowClear}
                    use12Hours={false}
                    minuteStep={minuteStep as any}
                    showNow={showNow}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};

export default TimePickerFilter;
